import { StoreState } from '@/redux/types';
import { getDesigns } from './getDesigns';

export const getDesign = (state: StoreState, designId: string) => getDesigns(state)[designId];
